<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">用户管理</span>

    <div class="box">
      <div style="margin-bottom:12px;">
        <el-button plain size="mini" type="primary" @click="add_user">
          创建用户
        </el-button>
      </div>

      <!-- <el-select
        size="mini"
        v-model="value"
        @change="select_change"
        placeholder="请选择"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select> -->

      <el-input
        v-model="value_name"
        size="mini"
        placeholder="请输入姓名"
        clearable
        style="width:120px;margin-right:12px;"
      ></el-input>
      <el-button
        size="mini"
        type="primary"
        icon="el-icon-search"
        @click="search"
      >
        搜索
      </el-button>

      <el-table :data="tableData" class="table" border stripe>
        <el-table-column type="index" label="#" width="40"></el-table-column>
        <el-table-column
          prop="CreatedAt"
          label="日期"
          min-width="90"
        ></el-table-column>
        <el-table-column label="账号状态" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Enabled" type="success">启用</el-tag>
            <el-tag v-else type="danger">封号</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="Name"
          label="用户名"
          width="120"
        ></el-table-column>
        <el-table-column prop="Nickname" label="昵称"></el-table-column>
        <el-table-column prop="Phone" label="权限" min-width="100">
          <template slot-scope="scope">
            <el-popover
              @show="look(scope.row)"
              placement="bottom"
              width="200"
              trigger="hover"
            >
              <el-tag
                style="margin-right:6px;"
                size="mini"
                v-if="jurisdiction.ApproveCourse == true"
              >
                审核课程
              </el-tag>
              <el-tag
                style="margin:6px;"
                size="mini"
                v-if="jurisdiction.CreateCourse == true"
              >
                创建课程
              </el-tag>
              <el-tag
                style="margin:6px;"
                size="mini"
                v-if="jurisdiction.ManageClasses == true"
              >
                班级管理
              </el-tag>
              <el-tag
                style="margin-right:6px;"
                size="mini"
                v-if="jurisdiction.CreateProblem == true"
              >
                添加题库
              </el-tag>
              <el-tag
                slot="reference"
                type="primary"
                size="mini"
                style="cursor: pointer;"
              >
                查看
              </el-tag>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="140">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="el-icon-edit"
              size="mini"
              @click="editCampus(scope.row)"
            >
              修改
            </el-button>
            <el-button
              v-if="scope.row.Enabled"
              type="danger"
              icon="el-icon-close"
              size="mini"
              @click="ban_button(scope.row)"
            >
              封号
            </el-button>
            <el-button
              v-else
              type="success"
              icon="el-icon-check"
              size="mini"
              @click="ban_button(scope.row)"
            >
              启用
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-position"
              size="mini"
              @click="distribution(scope.row)"
            >
              分配
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="padding:30px 0; float: right;"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[40, 60, 80]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 添加/修改用户弹框 -->
    <el-dialog
      :title="form.Id ? '修改用户' : '创建用户'"
      :close-on-click-modal="false"
      :visible.sync="add_user_dialog"
      width="50%"
    >
      <el-form
        ref="form_ref"
        :model="form"
        :rules="rules"
        label-width="56px"
        class="login_from"
        label-position="right"
      >
        <el-form-item label="头像" v-if="false">
          <el-upload
            class="avatar-uploader"
            :action="uploadURL"
            :on-success="upload_success"
          >
            <img v-if="form.avatar" :src="form.avatar" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="用户" prop="userName">
          <el-input v-model="form.userName" placeholder="请输入用户名">
          </el-input>
        </el-form-item>
        <el-form-item label="密码" :prop="form.Id ? '' : 'password'">
          <el-input
            show-password
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="form.nickname" placeholder="请输入昵称">
          </el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="form.Phone" placeholder="请输入手机号"> </el-input>
        </el-form-item>
        <el-form-item label="email">
          <el-input v-model="form.email" placeholder="请输入邮箱"> </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="add_user_dialog = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="add_user_determine" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 删除校长弹框 -->
    <el-dialog title="删除校长" :visible.sync="delete_principal" width="40%">
      <span>校长：</span>
      <el-select
        class="elselect"
        v-model="delete_select"
        placeholder="请选择校长"
      >
        <el-option
          v-for="item in delete_form.principal"
          :key="item.Name"
          :label="item.Name"
          :value="item.Name"
        >
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="delete_principal = false" size="mini"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="delete_principal_determine"
          size="mini"
        >
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 用户分配弹框 -->
    <el-dialog
      title="用户分配"
      :close-on-click-modal="false"
      :visible.sync="distribution_dialog"
      width="40%"
    >
      <p>
        用户：
        <span style="color:#999;">{{ active_distribution.Nickname }}</span>
      </p>
      <el-checkbox-group v-model="checkList">
        <el-checkbox label="审核课程"></el-checkbox>
        <el-checkbox label="创建课程"></el-checkbox>
        <el-checkbox label="班级管理"></el-checkbox>
        <el-checkbox label="添加题库"></el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="distribution_dialog = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="add_distribution_dialog" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import loading from "@/components/loading.vue";
import { postSchool, putSchool, delete_principal } from "@/api/admin.js";
import {
  getAllUser,
  add_user_api,
  edit_user_api,
  ban_user_api,
  edit_user_permission_api,
  post_permission_api,
} from "@/api/user.js";
import { upload_resources_api } from "@/api/resources.js";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    loading,
  },
  data() {
    return {
      rules: {
        // 验证用户名是否合法
        userName: [
          { required: true, message: "请输入登录名称", trigger: "blur" },
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" },
        ],
      },
      dialogVisible: false,
      add_user_dialog: false, // 添加/修改用户弹框
      delete_principal: false, // 删除校长弹框
      distribution_dialog: false, // 用户分配弹框
      form: {
        avatar: "",
        email: "",
        userName: "",
        nickname: "",
        password: "",
        Phone: "",
      },
      add_form_principal: { Name: "", headmaster: "" }, //添加校长表单
      tableData: [],
      options: [],
      delete_form: [],
      delete_select: "",
      uploadURL: "",
      active_distribution: {},
      checkList: ["审核课程"], // 选中多选框存储数据
      options: [
        {
          value: "所有",
          label: "所有",
        },
        {
          value: "校长",
          label: "校长",
        },
        {
          value: "老师",
          label: "老师",
        },
        {
          value: "学生",
          label: "学生",
        },
      ],
      value: "校长",
      user_query: {
        domain: {
          group: "SCHOOL",
          name: "",
        },
        subject: {
          group: "ROLE",
          name: "HEADMASTER",
        },
      },
      jurisdiction: {
        ApproveCourse: false,
        CreateCourse: false,
        CreateProblem: false,
        ManageClasses: false,
      },
      value_name: "",
      limit: 40,
      offset: 0,
      total: 0,
      loading_ok: "",
    };
  },

  created() {
    let _than = this;
    var test1 = setInterval(function() {
      if (_than.current) {
        _than.getAllUserFuntion();
        clearTimeout(test1);
      }
    }, 500);
    this.uploadURL = upload_resources_api();
  },

  methods: {
    //获取所有用户
    getAllUserFuntion() {
      this.user_query.domain.name = this.current;
      getAllUser(this.value_name, this.offset, this.limit)
        .then((res) => {
          res.data.Results.forEach((v) => {
            v.CreatedAt = this.filters.vdateAdd(v.CreatedAt);
          });

          this.loading_ok = false;
          this.tableData = res.data.Results;
          this.total = res.data.Total;
        })
        .catch(() => {
          this.loading_ok = false;
        });
    },

    addCampus() {
      if (this.$refs.form_ref !== undefined) {
        this.$refs.form_ref.clearValidate();
      }
      this.form = {};
      this.dialogVisible = true;
    },

    //确定按钮
    addDialog() {
      this.$refs.form_ref.validate((valid) => {
        if (valid) {
          let data = { name: this.form.Name };
          if (this.form.School) {
            if (this.form.School == this.form.Name) {
              this.$message.error("禁止修改相同名称！");
              return false;
            }
            putSchool(this.form.School, data).then(() => {
              this.getSchoolFuntion();
              this.$message.success("修改成功！");
            });
          } else {
            postSchool(this.form).then(() => {
              this.getSchoolFuntion();
              this.$message.success("创建成功！");
            });
          }
        }
      });
    },

    // 修改用户按钮
    editCampus(item) {
      this.form = {
        Id: item.Id,
        avatar: item.Avatar,
        email: item.Email,
        userName: item.Name,
        nickname: item.Nickname,
        password: "",
        Phone: item.Phone,
      };
      this.add_user_dialog = true;
    },

    // 添加用户弹框确定按钮
    add_user_determine() {
      this.$refs.form_ref.validate((valid) => {
        if (valid) {
          if (this.form.Id) {
            delete this.form.Id;
            edit_user_api(this.form).then(() => {
              this.getAllUserFuntion();
              this.$message.success("修改成功！");
              this.add_user_dialog = false;
            });
          } else {
            add_user_api(this.form).then(() => {
              this.getAllUserFuntion();
              this.$message.success("添加成功！");
              this.add_user_dialog = false;
            });
          }
        }
      });
    },

    // 删除校长按钮
    delete_principal_button(item) {
      this.delete_select = "";
      this.delete_form = item;
      this.delete_principal = true;
    },

    // 删除校长弹框确定
    delete_principal_determine() {
      if (!this.delete_select) {
        this.$message.error("请选择校长！");
        return false;
      }
      let data = {
        domain: {
          group: "SCHOOL",
          name: this.delete_form.Name,
        },
        pred: {
          group: "ROLE",
          name: "HEADMASTER",
        },
        succ: {
          group: "USER",
          name: this.delete_select,
        },
      };

      delete_principal(data).then(() => {
        this.getSchoolFuntion();
        this.delete_principal = false;
        this.$message.success("删除成功！");
      });
    },

    // 创建用户按钮
    add_user() {
      if (this.$refs.form_ref !== undefined) {
        this.$refs.form_ref.clearValidate();
      }
      this.form = {
        avatar: "",
        email: "",
        userName: "",
        nickname: "",
        password: "",
        Phone: "",
      };
      this.add_user_dialog = true;
    },

    // 头像上传成功
    upload_success(res) {
      console.log(res);
    },

    // 封号
    ban_button(item) {
      this.$confirm(item.Enabled ? "确定封号吗？" : "确定启用吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          ban_user_api({ enabled: !item.Enabled, user: item.Name }).then(() => {
            this.getAllUserFuntion();
            this.$message.success(item.Enabled ? "封号成功！" : "启用成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    // 分配
    distribution(item) {
      this.checkList = [];
      this.active_distribution = item;
      if (item.ApproveCourse) {
        this.checkList.push("审核课程");
      }

      if (item.CreateCourse) {
        this.checkList.push("创建课程");
      }

      if (item.ManageClasses) {
        this.checkList.push("班级管理");
      }

      if (item.CreateProblem) {
        this.checkList.push("添加题库");
      }
      this.distribution_dialog = true;
    },

    // 分配用户确定
    add_distribution_dialog() {
      let data = {
        approveCourse: false,
        createCourse: false,
        manageClasses: false,
        createProblem: false,
        userId: this.active_distribution.Id,
      };

      this.checkList.forEach((v) => {
        if (v == "审核课程") {
          data.approveCourse = true;
        }
        if (v == "创建课程") {
          data.CreateCourse = true;
        }
        if (v == "班级管理") {
          data.manageClasses = true;
        }
        if (v == "添加题库") {
          data.CreateProblem = true;
        }
      });
      edit_user_permission_api(data).then((res) => {
        this.getAllUserFuntion();
        this.distribution_dialog = false;
      });
    },

    // 下拉框切换事件
    select_change(item) {
      if (item == "所有") {
        this.user_query = {
          domain: {
            group: "",
            name: "",
          },
          subject: {
            group: "",
            name: "",
          },
        };
      } else if (item == "校长") {
        this.user_query = {
          domain: {
            group: "SCHOOL",
            name: this.current,
          },
          subject: {
            group: "ROLE",
            name: "HEADMASTER",
          },
        };
      } else if (item == "老师") {
        this.user_query = {
          domain: {
            group: "SCHOOL",
            name: this.current,
          },
          subject: {
            group: "ROLE",
            name: "TEACHER", //STUDENT
          },
        };
      } else if (item == "学生") {
        this.user_query = {
          domain: {
            group: "SCHOOL",
            name: this.current,
          },
          subject: {
            group: "ROLE",
            name: "STUDENT",
          },
        };
      }

      this.getAllUserFuntion();
    },

    //查看权限
    look(v) {
      let data = {
        domain: {
          group: "SCHOOL",
          name: this.current,
        },
        subject: {
          group: "USER",
          name: v.Name,
        },
      };
      post_permission_api(v.Id, data).then((res) => {
        this.jurisdiction = res.data;
      });
    },

    //搜索
    search() {
      this.getAllUserFuntion();
    },

    //分页
    handleSizeChange(val) {
      this.limit = val;
      this.getAllUserFuntion();
    },

    //分页
    handleCurrentChange(val) {
      this.offset = (val - 1) * this.limit;
      this.getAllUserFuntion();
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
    .box {
        margin-top:30px;
    }
   .table {
     margin-top:20px;
   }
   .elselect {
     margin-top:12px;
   }
   .elTagClass {
    margin-right:6px;
  }
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border:1px solid #eee;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-checkbox-group {
    margin-top:20px;
  }

  .el-select {
    margin-left:12px;
  }
</style>
